export default "__VITE_ASSET__oiJx0o2r__"